export default __webpack_public_path__ + "static/media/closer-hunt.a830d000.txt";